import { render, staticRenderFns } from "./revised_objectivesPagination.vue?vue&type=template&id=64496e1a&"
import script from "./revised_objectivesPagination.vue?vue&type=script&lang=js&"
export * from "./revised_objectivesPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports